import { Guid } from "../../types/guid.type";
import { Address, IAddressInfo } from "../core/address/address";
import { EntityDocumentStatusBase, IEntityDocumentStatusBaseInfo } from "../entity/document/entity-document-status.base";
import { IIdentityInfo, Identity } from "../identity/identity";
import { LvfDeliveryMode } from "../../enum/daily-activity/lvf-delivery-mode";
import { LvfAppModule } from "../../enum/application/lvf-app-module";
import { ITicketDeliveryProductInfo, TicketDeliveryProduct } from "./ticket-delivery-product";
import { ITeamInfo, Team } from "../organization/team/team";

export interface ITicketDeliveryInfo extends IEntityDocumentStatusBaseInfo {
  RecipientIdentityUid?: Guid;
  RecipientTeamUid?: Guid;
  RecipientIdentity?: IIdentityInfo;
  RecipientTeam?: ITeamInfo;
  LvfDeliveryMode?: LvfDeliveryMode;
  EntityAddressUid?: Guid;
  EntityAddress?: IAddressInfo;
  Products?: ITicketDeliveryProductInfo[];
}

export class TicketDelivery extends EntityDocumentStatusBase {
  RecipientIdentityUid?: Guid;
  RecipientTeamUid?: Guid;
  RecipientIdentity?: Identity;
  RecipientTeam?: Team;
  LvfDeliveryMode?: LvfDeliveryMode;
  EntityAddressUid?: Guid;
  EntityAddress?: Address;
  Products?: TicketDeliveryProduct[];

  constructor(info: ITicketDeliveryInfo) {
    super(info);
    this.LvfAppModule = LvfAppModule.TICKET;

    this.LvfDeliveryMode = info.LvfDeliveryMode ?? LvfDeliveryMode.DIRECT_TO_REQUESTER;

    this.RecipientIdentityUid = info.RecipientIdentityUid;
    this.RecipientIdentity = Identity.createInstance(Identity, info.RecipientIdentity);

    this.RecipientTeamUid = info.RecipientTeamUid;
    this.RecipientTeam = Team.createInstance(Team, info.RecipientTeam);

    this.EntityAddressUid = info.EntityAddressUid;
    this.EntityAddress = Address.createInstance(info.EntityAddress);

    this.Products = info.Products?.map(p => new TicketDeliveryProduct(p)) ?? [];
  }
}
